import { Show, Tab, TabbedShowLayout, TabbedShowLayoutTabs } from "react-admin";
import ReasonSubreasonMetaShow from "./ReasonSubreasonMetaShow";

const ReasonSubreasonTabs = () => (
    <TabbedShowLayout
        tabs={
            <TabbedShowLayoutTabs
                variant="scrollable"
                scrollButtons="auto"
                selectionFollowsFocus={true}
            />
        }
    >
        <Tab label="Details" key="Details">
            <ReasonSubreasonMetaShow />
        </Tab>
    </TabbedShowLayout>
);

const ReasonSubreasonShow = (props: any) => (
    <Show {...props} actions={false}>
        <ReasonSubreasonTabs />
    </Show>
);

export default ReasonSubreasonShow;
